const CheckIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 0.25C20.0422 0.25 25.75 5.95775 25.75 13C25.75 20.0422 20.0422 25.75 13 25.75C5.95775 25.75 0.25 20.0422 0.25 13C0.25 5.95775 5.95775 0.25 13 0.25Z"
        fill="#08B263"
      />
      <path
        d="M18.6667 10.166L11.5834 17.2493L7.33337 12.9993"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckIcon;
